export default "__VITE_ASSET__DOrMLig3__"